<template>
    <!-- @vue-generic {VenueBundleResponse} -->
    <QueryBundle
        v-slot="{ status, result, totalResults, lastPageNumber, currentPageNumber, loadMore }"
        bundle-type="venues"
    >
        <StateSwitch :state="status">
            <template #default>
                <slot
                    :result
                    :load-more
                    :total-results
                    :last-page-number
                    :current-page-number
                />
            </template>

            <template #loading>
                <slot name="loading">
                    <BaseLoader />
                </slot>
            </template>

            <template #error>
                <slot name="error">
                    <NoResults class="no-results--centered">
                        Er ging iets fout tijdens het laden van de events.
                    </NoResults>
                </slot>
            </template>
        </StateSwitch>
    </QueryBundle>
</template>
